import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import API from "../../api/phx";
import { useCart } from "../../hooks/useCart";
import { getCurrency } from "../../utils/getCurrency";
import StandardButton from "../UI/StandardButton";
import StandardH5 from "../UI/StandardH5";
import StandardValidation from "../UI/StandardValidation";
import StandardInputWrapper from "../UI/StandardInputWrapper";
import StandardLabel from "../UI/StandardLabel";
import StandardFormItem from "../UI/StandardFormItem";
import { ABContext } from "../../contexts/ab-context";
import { getDomainConfig } from "../../config/config";
import { formatCurrency, getGeo } from "../../utils/formatCurrency";

const GiftCard = (props) => {
  const { t } = useTranslation("common");
  const config = getDomainConfig();
  const abContext = useContext(ABContext);

  const {
    data: cartContents,
    refetch: cartRefresh,
  } = useCart();

  const [isGiftCardApplied, setIsGiftCardApplied] = useState(false);
  const [giftCardCode, setGifCardCode] = useState("");
  const [giftCards,setGiftCards] = useState([]);
  const [error, setError] = useState(false)

  const geo = getGeo();

  useEffect(() => {
    if(cartContents.data.gift_cards){
      setGiftCards(cartContents.data.gift_cards);
      cartContents.data.gift_cards.length > 0 && setIsGiftCardApplied(true);
    }
  },[cartContents])

  // CRO-1381-checkout-redesign
  const [isCro1381, setIsCro1381] = useState(false);

  useEffect(() => {
    if ((config.brand !== 'Sw') && abContext.cro1381 !== undefined) setIsCro1381(abContext.cro1381.variant);
  }, [abContext]);
  // END CRO-1381-checkout-redesign

  const handleAddGiftCardFormClick = (event) => {
    event.preventDefault();
    if (giftCardCode) {
      API.post("/cart/gift_cards", { serial: giftCardCode }, { withCredentials: true }).then(
        (giftCardResponse) => {
          // Show success message.
          setIsGiftCardApplied(true);

          //clear input field
          setGifCardCode("");

          // Refresh cart.
          cartRefresh();
        },
        (error) => {
          console.warn("Error adding gift card code:", error);
          // Show fail message.
          setIsGiftCardApplied(false);
          setError(true);
        }
      );
    }
  };

  const handleRemoveGiftCardFormClick = (event,gift_card_id) => {
    event.preventDefault();
    if (gift_card_id) {
      API.delete("/cart/gift_cards", { data : { gift_card_id: Number(gift_card_id) } }, { withCredentials: true }).then(
        (giftCardResponse) => {
          // Refresh cart.
          cartRefresh();
        },
        (error) => {
          console.warn("Error removing gift card code:", error);
          // Show fail message.
          setIsGiftCardApplied(false);
          setError(true);
        }
      );
    }
  }
  return (
    <StandardFormItem className="textItem" id="form-item-girt-card">
      <StandardLabel htmlFor={"gift-card"}>
        {t('gift-card-number')}
      </StandardLabel>
      <StandardInputWrapper className={`wrapperWithBtn ${isCro1381 && 'cro1381GiftWrapper'}`}>
      <input
        type="text"
        id="gift-card"
        name="gift-card"
        onChange={(e) => setGifCardCode(e.target.value)}
        value={giftCardCode}
      />
        <StandardButton
          className="sideButton"
          id="gift-card-apply"
          value="Apply Gift card"
          onClick={handleAddGiftCardFormClick}
        >
          {t("apply-gift-card")}
        </StandardButton>
        {isGiftCardApplied && (
        <>
          <StandardValidation className="input" icon="true" valType="success">
            {t("the-gift-card-was-applied")}
          </StandardValidation>
          {giftCards.map((gift_card) => {
            return (
              <div className="giftApplied">
                <p>
                  {gift_card.serial} (
                  {formatCurrency(gift_card.balance, geo)})
                </p>
                <button
                  onClick={(event) =>
                    handleRemoveGiftCardFormClick(event, gift_card.gift_card_id)
                  }
                >
                  {t("gift-remove")}
                </button>
              </div>
            );
          })}
        </>
      )}
      {!isGiftCardApplied && error && (
        <StandardValidation className="input" icon="true" valType="error">
          {t("gift-card-does-not-exist-or-is-not-valid")}
        </StandardValidation>
      )}
      </StandardInputWrapper>
    </StandardFormItem>
  );
};

export default GiftCard;
